// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5628":"css/admin-app.6935","9052":"css/app.6935"}[chunkId] + ".css";
};